import React, { useEffect, useState } from 'react';
import './ValidationReferencesFranco.scss';
import IconItem from '../../../../../../components/Item/IconItem/IconItem';
import { faArrowLeft, faArrowRight, faCheck, faCircleMinus, faCirclePlus, faClose, faPencil, faTrashCan, faWarning } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import CURRENCY from 'utils/constants/currency';
import { Trans, useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IImportFileNew, IParts } from 'interfaces/price';
import QuantityInput from 'components/inputs/QuantityInput/QuantityInput';

import { notify } from 'utils/marketplace';
import Pagination from 'components/pagination/Pagination';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { setCloseModal } from 'store/slices/proformaAutomotorModal.slice';
import { formatNumberWithSpaces } from 'utils/utils';
import ReferenceSearchOrder from '../ReferenceSearchOrder/ReferenceSearchOrder';


type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
  stepModalNext: string;
};

type IOption = {
  label: string;
  value: string;
  logo?: string;
};
type FormValues = {
  selectedSupplier: IOption | null;
};


const ValidationReferencesFranco: React.FC<Props> = (props) => {

  const [francoListNotValidated, setFrancoNotValidated] = useState<IImportFileNew[]>([]);
  const [francoCodFou, setFrancoCodFou] = useState<string>('');
  const [data, setData] = useState<IImportFileNew[]>([]);
  const user = JSON.parse(localStorage.getItem('userData')!);
  const [lastIndex, setLastIndex] = useState<number>(0);
  const [selectedItem, setSelectedItem] = useState<IImportFileNew>();
  const [resetInputRef, setResetInputRef] = useState(false);
  const [openRef, setOpenRef] = useState(false);
  const [quantityNewRef, setQuantityNewRef] = useState<{ id: number; index: number; quantity: number }>({ id: 0, index: 0, quantity: 1 });
  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const [disabledNextBtn, setDisabledNextBtn] = useState(false);
  const [dataPagination, setDataPagination] = useState<IParts[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(5);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [countNotValidFranco, setCountNotValidFranco] = useState<number>(0);
  const [listFrancoCodFou, setListFrancoCodFou] = useState<string[]>([]);
  const [suppliers, setSuppliers] = useState<IOption[]>([]);
  const dispatch = useDispatch();

  const { control, setValue } = useForm<FormValues>({
  });

  useEffect(() => {
    if (props.stepModalNext === 'ValidationReferencesFranco') {
      const data = proformaFile.partsWithReplacements || [];
      const francoNotValidatedFiltered = data.filter((item) => item.franco !== undefined && item.franco !== null && item.franco !== '');

      const francoNotValidated = francoNotValidatedFiltered.filter((item) => {
        const franco = item.franco || 0;
        const totalPrice = item.parts.map((part) => +part.total).reduce((acc: number, price: number) => acc + price, 0);

        return franco > totalPrice;
      });

      setFrancoNotValidated(francoNotValidated);
      setSuppliersList(francoNotValidated);

    }
  }, [props.stepModalNext]);


  const setSuppliersList = (francoNotValidated: IImportFileNew[]) => {
    const suppliers: IOption[] = francoNotValidated.reduce((acc: IOption[], row) => {
      const supplierName = row.name || '-';

      if (!acc.find((s) => s.value === supplierName)) {
        acc.push({
          label: supplierName,
          value: row.code_fou,
          logo: row.supplier_logo || '/images/car-part-placeholder-big.png',
        });
      }

      return acc;
    }, []);

    setSuppliers(suppliers);
  };


  useEffect(() => {
    if (proformaFile && francoCodFou == '') {
      const data = proformaFile.partsWithReplacements || [];
      const francoNotValidatedFiltered = data.filter((item) => item.franco !== undefined && item.franco !== null && item.franco !== '');

      const francoNotValidated = francoNotValidatedFiltered.filter((item) => {
        const franco = item.franco || 0;
        const totalPrice = item.parts.map((part) => +part.total).reduce((acc: number, price: number) => acc + price, 0);

        return franco > totalPrice;
      });

      if (francoNotValidated.length > 0) {
        setFrancoNotValidated(francoNotValidated);
        setCountNotValidFranco(francoNotValidated.length);
        setListFrancoCodFou(francoNotValidated.map((item) => item.code_fou));
        setSuppliersList(francoNotValidated);

      } else {
        props.setStepModal('ValidationReferencesResultInfo');
      }


    }

    if (francoCodFou) {

      const francoNotValidatedFiltered = francoListNotValidated.filter((item) => item.code_fou === francoCodFou);

      setData(francoNotValidatedFiltered);
      setFrancoCodFou(francoNotValidatedFiltered[0].code_fou);
      setValue('selectedSupplier', suppliers.find((item) => item.value == francoNotValidatedFiltered[0].code_fou) || null);


    }
  }, [francoCodFou]);


  useEffect(() => {

    if (francoListNotValidated.length > 0) {
      const allIndexes = francoListNotValidated.flatMap(item =>
        item.parts
          .map(part => part.index)
          .filter((index): index is number => typeof index === 'number')
      );

      if (allIndexes.length > 0) {
        setLastIndex(Math.max(...allIndexes));
      }
    } else {
      setFrancoCodFou('');
    }

    if (francoListNotValidated.length === 1) {
      setFrancoCodFou(francoListNotValidated[0].code_fou);
    }

  }, [francoListNotValidated]);


  useEffect(() => {
    if (data.length > 0) {


      const totalPages = Math.ceil(data[0].parts.length / itemsPerPage);

      setTotalPages(totalPages);
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const paginatedData = data[0].parts.slice(startIndex, endIndex);

      setDataPagination(paginatedData);
    }
  }, [data, currentPage, itemsPerPage]);

  useEffect(() => {
    if (francoCodFou !== '') {
      if (data.some(item => Number(item.parts?.map((part) => Number(part.total) || 0).reduce((acc, price) => acc + price, 0).toFixed(2)) >= Number(item.franco!))) {
        setDisabledNextBtn(true);
      } else {
        setDisabledNextBtn(false);
      }

      if (data.length === 0) {
        setFrancoCodFou('');
      }
    }
  }, [data]);

  const handleClose = () => {
    props.setOpenModal(false);
    dispatch(setCloseModal(true));
  };

  const removeRow = (reference, index, codfou) => {
    const updatedData = data.map((item) => {
      const updatedParts = item.parts.filter((part) => !(part.reference == reference && part.index == index && part.codfou == codfou));

      return { ...item, parts: updatedParts };
    });

    const filteredData = updatedData.filter((item) => Array.isArray(item.parts) && item.parts.length !== 0);


    const parts = proformaFile.partsWithReplacements || [];

    const updatedParts = parts.map((item) => {
      if (item.code_fou === francoCodFou) {
        const updatedItem = { ...item };

        updatedItem.parts = item.parts.filter((part) => !(part.reference == reference && part.index == index && part.codfou == codfou));

        return updatedItem;
      }

      return item;
    }
    );

    localStorage.setItem('proformaFileInProgress', JSON.stringify({
      ...proformaFile,
      count: proformaFile.count - 1,  // Decrease the count by 1
      partsWithReplacements: updatedParts.filter((item) => item.parts.length !== 0)
    }));


    setData(filteredData);


    if (currentPage === 1) {
      setCurrentPage(currentPage);
    }
    // Dacă pagina curentă e mai mare decât totalul de pagini (după ștergere), mergi pe ultima pagină validă
    else if (currentPage > Math.ceil(filteredData[0].parts.length / itemsPerPage)) {
      setCurrentPage(Math.ceil(filteredData[0].parts.length / itemsPerPage));
    } else {
      setCurrentPage(currentPage);
    }

  };

  const setValueItems = (value: { id: number; index: number; quantity: number }) => {

    const updatedData = data.map((item) => {
      const updatedParts = item.parts.map((part) => {
        if (part.index === value.index) {
          return {
            ...part, quantity: value.quantity, total: (Number(part.price) * value.quantity).toFixed(2), // Update the total based on the new quantity
          };
        }

        return part;
      });

      return { ...item, parts: updatedParts };

    });


    const parts = proformaFile.partsWithReplacements || [];

    const updatedParts = parts.map((item) => {
      if (item.code_fou === francoCodFou) {
        const updatedItem = { ...item };

        updatedItem.parts = item.parts.map((part) => {
          if (part.index === value.index) {
            return {
              ...part, quantity: value.quantity, total: (Number(part.price) * value.quantity).toFixed(2), // Update the total based on the new quantity
            };
          }

          return part;
        });

        return updatedItem;
      }

      return item;
    }
    );

    localStorage.setItem('proformaFileInProgress', JSON.stringify({ ...proformaFile, partsWithReplacements: updatedParts }));


    setData(updatedData);
  };

  const handleSubmit = () => {
    const validateFranco = data.some(item => Number(item.parts?.map((part) => Number(part.total) || 0).reduce((acc, price) => acc + price, 0).toFixed(2)) <= Number(item.franco!));


    if (validateFranco) {
      notify(t('_franco_order_not_valid'), 'error', t('_error'));

      return;
    }

    if (countNotValidFranco > 1) {
      if (data.length > 0) {
        setCountNotValidFranco(countNotValidFranco - 1);
      }

      setListFrancoCodFou(listFrancoCodFou.filter((item) => item !== francoCodFou));
      setSuppliers(suppliers.filter(item => item.value !== francoCodFou));

      const codfouSelectd = listFrancoCodFou.filter((item) => item !== francoCodFou)[0] || '';

      setFrancoCodFou(codfouSelectd);
      setCurrentPage(1);
      setValue('selectedSupplier', suppliers.find((item) => item.value == codfouSelectd) || null);
      setOpenRef(false);
      setSelectedItem(undefined);

    } else {

      const validateFranco = data.some(item => Number(item.parts?.map((part) => Number(part.total) || 0).reduce((acc, price) => acc + price, 0).toFixed(2)) <= Number(item.franco!));


      if (validateFranco) {

        props.setStepModal('ValidationReferencesFrancoComment');
      } else {
        props.setStepModal('ValidationReferencesResultInfo');
      }
    }
  };


  const addNewReference = () => {

    const isRefExists = data.some((item) =>
      item.parts.some((part) => part.reference == selectedItem?.parts[0].reference)
    );

    if (isRefExists) {
      notify(t('_item_already_exists'), 'warning');

      return;
    }


    if (selectedItem) {
      const updatedData = data.map((item) => {
        if (item.code_fou === francoCodFou) {
          const updatedParts = [{ ...selectedItem.parts[0], quantity: quantityNewRef.quantity, index: lastIndex + 1, total: (Number(selectedItem.parts[0].price) * quantityNewRef.quantity).toFixed(2) }, ...item.parts];

          return { ...item, parts: updatedParts };
        }

        return item;
      });

      setData(updatedData);
      notify(t('_reference_added_successfully'), 'success', t('_success'));
      const parts = proformaFile.partsWithReplacements || [];

      parts.count = parts.count + 1;

      const updatedParts = parts.map((item) => {
        if (item.code_fou === francoCodFou) {
          const updatedItem = { ...item };

          updatedItem.parts = [...item.parts, { ...selectedItem.parts[0], quantity: quantityNewRef.quantity, index: lastIndex + 1, total: (Number(selectedItem.parts[0].price) * quantityNewRef.quantity).toFixed(2), supplier_name: selectedItem.parts[0].name }];

          return updatedItem;
        }

        return item;
      }
      );

      localStorage.setItem('proformaFileInProgress', JSON.stringify({ ...proformaFile, partsWithReplacements: updatedParts }));


      setOpenRef(false);
      setSelectedItem(undefined);
      setQuantityNewRef({ id: 0, index: 0, quantity: 1 });
    }
  };

  const clearOpenRef = () => {
    setSelectedItem(undefined);
    setQuantityNewRef({ id: 0, index: 0, quantity: 1 });
  };


  const handlePageClick = (page: number) => {
    setCurrentPage(page);

  };

  const deleteFrancoCodFou = (codFou: string, type: string) => {

    const countParts = francoListNotValidated?.filter(item => item.code_fou === codFou).length || 0;
    const updatedFrancoList = francoListNotValidated.filter(item => item.code_fou !== codFou);

    setFrancoNotValidated(updatedFrancoList);
    setSuppliers(suppliers.filter(item => item.value !== codFou));
    setCountNotValidFranco(countNotValidFranco - 1);
    setListFrancoCodFou(listFrancoCodFou.filter((item) => item !== codFou));

    const codfouSelectd = listFrancoCodFou.filter((item) => item !== codFou)[0] || '';

    if (type === 'list') {
      setFrancoCodFou('');
    } else {
      setFrancoCodFou(codfouSelectd);
    }

    setCurrentPage(1);
    setValue('selectedSupplier', suppliers.find((item) => item.value == codfouSelectd) || null);
    setOpenRef(false);
    setSelectedItem(undefined);


    const updatedParts = (proformaFile.partsWithReplacements || []).filter(
      item => item.code_fou !== codFou
    );

    const updatedProforma = {
      count: proformaFile.count - countParts, // Decrease the count by the number of parts removed
      ...proformaFile,
      partsWithReplacements: updatedParts
    };


    localStorage.setItem('proformaFileInProgress', JSON.stringify(updatedProforma));
  };


  const show = (id: string, type, event: React.MouseEvent) => {
    event.stopPropagation();
    document.getElementById(String(id))!.style.display = type;
  };

  return (
    <div className="validation-custumer-order-franco-modal" >
      <div className="close upload_order_info_franco_close">
        <IconItem icon={faClose} onClick={() => { handleClose(); }} />
      </div>


      <div className="validation-customer-modal-body">
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-title">{t('_order_verification_of_FRANCO')}</div>
          <div className="validation-customer-modal-subtitle">
            <Trans
              i18nKey="_validate_franco_message"
              components={{ bold: <br /> }}

            />
          </div>
        </div>
        {
          francoCodFou == '' ?
            <React.Fragment>

              <div className="validation-customer-modal-row">
                {francoListNotValidated.length > 0 ?

                  francoListNotValidated.map((item) => {
                    return (
                      <div className="customer-order-card" key={item.code_fou}>
                        <div className="supplier-logo">

                          <img src={item.supplier_logo ? item.supplier_logo : '/images/car-part-placeholder-big.png'} onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = '/images/car-part-placeholder-big.png';
                          }} alt="Logo"
                          />
                        </div>
                        <div className="supplier-info">
                          <div className="supplier-name">{item.name}</div>
                          <div className="details">
                            <span>{t('_franco_order')}: <span className="highlight">{formatNumberWithSpaces(item.franco)} €</span></span>
                            <span> {t('_order_amount')}:<span className="amount_red"> {formatNumberWithSpaces(item.parts?.map((part) => Number(part.total) || 0).reduce((acc, price) => acc + price, 0).toFixed(2))}   {CURRENCY[user!.currency]}</span>
                            </span>
                          </div>
                          <div className="action">
                            <button className="edit-button" onClick={() => { setFrancoCodFou(item.code_fou); }} >
                              <FontAwesomeIcon icon={faPencil} className="icon" /> {t('_edit_order')}
                            </button>
                            <div className="delete-button-list" onClick={(event) => show('delete-all-codFou-' + item.code_fou, 'block', event)} >
                              <FontAwesomeIcon icon={faTrashCan} className="icon" /> {t('_delete_reference_order')}

                              <div className="tooltip-order"
                                id={String('delete-all-codFou-' + item.code_fou)}
                                onMouseLeave={(event) =>
                                  setTimeout(() => {
                                    show(String('delete-all-codFou-' + item.code_fou), 'none', event);
                                  }, 100)
                                }
                              >
                                <div className="tooltip_lable">
                                  <button className="yes" onClick={() => deleteFrancoCodFou(item.code_fou, 'list')}><FontAwesomeIcon icon={faCheck} /> {t('_yes')}</button>
                                  <button className="no" onClick={(event) => show('delete-all-codFou-' + item.code_fou, 'none', event)}><FontAwesomeIcon icon={faClose} /> {t('_no')}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })

                  : (
                    <div className="no-data">
                      <FontAwesomeIcon icon={faWarning} className="warning-icon" />
                      <span>{t('_no_data_found')}</span>
                    </div>
                  )}
              </div>
              <div className="validation-customer-modal-row">
                <div className="validation-customer-modal-button">
                  <DefaultButton className="validation-customer-modal-btn upload_order_info_franco" text={t('_validate_the_order')} onClick={() => {
                    // props.setStepModal('ValidationReferencesFrancoComment');
                    handleSubmit();
                  }}
                  />
                  <DefaultButton className="validation-customer-modal-btn cancel upload_order_info_franco_cancel" text={t('_cancel')} onClick={() => { handleClose(); }} />

                </div>

              </div>
            </React.Fragment>
            : null
        }


        {
          francoCodFou && (

            <div className="validation-customer-modal-row">
              {data.map((item) => {
                return <div className="customer-order-card-table" key={item.code_fou}>
                  {suppliers.length > 1 &&
                    <div className="validation-customer-modal-select ">
                      {t('_supplier')}
                      <Controller
                        control={control}
                        name="selectedSupplier"
                        defaultValue={suppliers.find((sup) => sup.value == francoCodFou)}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            value={value}
                            className="validation-customer-modal-select-input"
                            onChange={(val) => {
                              onChange(val);
                              setFrancoCodFou(val?.value || '');
                              setCurrentPage(1);
                              setOpenRef(false);
                              clearOpenRef();
                            }}
                            options={suppliers}
                            formatOptionLabel={(option) => (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {option.logo && <img src={option.logo ? option.logo : '/images/car-part-placeholder-big.png'} onError={({ currentTarget }) => { currentTarget.onerror = null; currentTarget.src = '/images/car-part-placeholder-big.png'; }} alt="Logo" height={18} />}
                                <span>{option.label}</span>
                              </div>
                            )}
                            placeholder={t('_select') + ' ' + t('_supplier')}
                            isClearable={false}
                            menuPlacement="top"
                            menuPosition="fixed"
                            isDisabled={suppliers.length === 1}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 50 }) }}
                            isSearchable={false}
                            isLoading={false}
                          />
                        )}
                      />
                    </div>
                  }
                  <div className="supplier-info">
                    <div className="details">
                      <span>{t('_franco_order')}: <span className="highlight">{formatNumberWithSpaces(item.franco)} €</span></span>
                      <span> {t('_total_amount')}:<span className={disabledNextBtn ? 'amount_green' : 'amount_red'}> {formatNumberWithSpaces(item.parts?.map((part) => Number(part.total) || 0).reduce((acc, price) => acc + price, 0).toFixed(2))} {CURRENCY[user!.currency]}</span>
                      </span>
                    </div>
                  </div>
                </div>;
              }
              )}
              <table className="validation-customer-modal-table">
                <thead>
                  <tr >
                    <th className="text-align-left"> {t('_reference')} / {t('_description')}</th>
                    <th >{t('_brand')}</th>
                    <th >{t('_quantity_order')}</th>
                    <th >{t('_unit_price')}</th>
                    <th >{t('_total_rates')}</th>
                    <th className="text-align-right float-right">
                      <div className="delete-button-table" onClick={(event) => show('delete-all-codFou-table-' + francoCodFou, 'block', event)} key={francoCodFou}>
                        <FontAwesomeIcon icon={faTrashCan} className="icon" /> {t('_delete_all')}

                        <div className="tooltip-order-table"
                          id={String('delete-all-codFou-table-' + francoCodFou)}
                          onMouseLeave={(event) =>
                            setTimeout(() => {
                              show(String('delete-all-codFou-table-' + francoCodFou), 'none', event);
                            }, 100)
                          }
                        >
                          <div className="tooltip_lable_table">
                            <button className="yes" onClick={() => deleteFrancoCodFou(francoCodFou, 'table')}><FontAwesomeIcon icon={faCheck} /> {t('_yes')}</button>
                            <button className="no" onClick={(event) => show('delete-all-codFou-table-' + francoCodFou, 'none', event)}><FontAwesomeIcon icon={faClose} /> {t('_no')}</button>
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dataPagination.map((part: IParts) => {

                    return (
                      <tr key={part.index + part.reference!}>
                        <td className="text-align-left">
                          {part.description ? `${part.reference ?? ''} / ${part.description}` : part.reference ?? ''}
                        </td>
                        <td>
                          <img src={part?.supplier_logo ? part?.supplier_logo : '/images/car-part-placeholder-big.png'} onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = '/images/car-part-placeholder-big.png';
                          }} alt="provider-logo" height={16}
                          />
                        </td>
                        <td>
                          <QuantityInput
                            value={part.quantity!}
                            index={part.index!}
                            setValueItems={setValueItems}
                          />
                        </td>
                        <td>{part.price ? `${formatNumberWithSpaces(Number(part.price).toFixed(2))} ${CURRENCY[user!.currency]}` : '-'}</td>
                        <td>{part.total ? `${formatNumberWithSpaces(Number(part.total).toFixed(2))} ${CURRENCY[user!.currency]}` : '-'}</td>
                        <td className="text-align-right">

                          <div className="remove" onClick={(event) => show('delete' + part.index + part.reference, 'block', event)} >
                            <FontAwesomeIcon icon={faTrashCan} />
                            <div className="tooltip-order"
                              id={String('delete' + part.index + part.reference)}
                              onMouseLeave={(event) =>
                                setTimeout(() => {
                                  show(String('delete' + part.index + part.reference), 'none', event);
                                }, 100)
                              }
                            >
                              <div className="tooltip_lable">
                                <button className="yes" onClick={() => removeRow(part.reference, part.index, part.codfou)}><FontAwesomeIcon icon={faCheck} /> {t('_yes')}</button>
                                <button className="no" onClick={(event) => show('delete' + part.index + part.reference, 'none', event)}><FontAwesomeIcon icon={faClose} /> {t('_no')}</button>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );

                  })}
                  {openRef && (
                    <tr>
                      <td className="text-align-left">
                        <ReferenceSearchOrder index={lastIndex + 1} setSelectedItem={setSelectedItem} resetInputRef={resetInputRef} setResetInputRef={setResetInputRef} codFou={francoCodFou} data={data} />
                      </td>
                      <td></td>
                      <td>
                        <QuantityInput
                          value={quantityNewRef.quantity}
                          index={lastIndex + 1}
                          setValueItems={setQuantityNewRef}
                        />
                      </td>
                      <td>
                        {selectedItem?.parts[0].price && selectedItem?.parts[0].price != 0 ? formatNumberWithSpaces(Number(selectedItem?.parts[0].price).toFixed(2)) : '-'} {CURRENCY[user!.currency]}
                      </td>
                      <td>
                        {selectedItem?.parts[0].price && selectedItem?.parts[0].price != 0 ? formatNumberWithSpaces(Number(Number(selectedItem?.parts[0].price) * quantityNewRef.quantity).toFixed(2)) : '-'} {CURRENCY[user!.currency]}
                      </td>

                      <td>
                        <div className="validate" onClick={() => { addNewReference(); }} > <FontAwesomeIcon icon={faCheck} />     {t('_validate')} </div>
                      </td>
                    </tr>
                  )}

                </tbody>
                <tfoot>

                  <tr>
                    <td colSpan={6} className="new-ref" onClick={() => { setOpenRef(!openRef); clearOpenRef(); }} > {!openRef ? <React.Fragment><FontAwesomeIcon icon={faCirclePlus} /> {t('_add_a_new_reference')}</React.Fragment> : <React.Fragment><FontAwesomeIcon icon={faCircleMinus} /> {t('_hide_new_reference')}</React.Fragment>}  </td>

                  </tr>
                </tfoot>
              </table>
              {totalPages > 1 && (
                <Pagination pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} hiddenParamPage iconsPrevious={faArrowLeft} iconsNext={faArrowRight} />
              )}

              <div className="validation-customer-modal-button">
                {/* <DefaultButton className="validation-customer-modal-btn upload_order_info_franco_list" text={countNotValidFranco == 1 ? t('_validate_the_order') : t('_validate_Franco_and_move_on_to_the_next_one')} onClick={() => { handleSubmit(); }} /> */}
                <DefaultButton className="validation-customer-modal-btn upload_order_info_franco_list" text={t('_validate_the_order')} onClick={() => { handleSubmit(); }} />

                <DefaultButton className="validation-customer-modal-btn cancel upload_order_info_franco_list_cancel" text={t('_cancel')} onClick={() => { handleClose(); }} />

              </div>


            </div>

          )
        }


      </div >
    </div >
  );

};

ValidationReferencesFranco.displayName = 'ValidationReferencesFranco';

export default ValidationReferencesFranco;